import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FiSave, FiArrowRight } from 'react-icons/fi';

const ActionBar = ({ currentProject }) => {
  const [saving, setSaving] = useState(false);

  const handleSaveAndExit = async () => {
    setSaving(true);
    
    try {
      // Update project status if needed
      await fetch(`/api/projects/${currentProject.id}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          status: 'in-progress'
        }),
      });
      
      // Redirect to main dashboard
      const dashboardUrl = process.env.REACT_APP_MAIN_DASHBOARD_URL || 'https://app.gyso.au';
      window.location.href = dashboardUrl;
    } catch (err) {
      console.error('Failed to save:', err);
      setSaving(false);
    }
  };

  const handleContinueToBuild = () => {
    const identityAppUrl = process.env.REACT_APP_IDENTITY_APP_URL || 'https://identity.gyso.au';
    const projectKey = currentProject.project_key;
    window.location.href = `${identityAppUrl}?projectKey=${projectKey}`;
  };

  return (
    <motion.div
      initial={{ y: 100 }}
      animate={{ y: 0 }}
      className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-lg"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex items-center justify-between">
          <div className="text-sm text-gray-600">
            Project: <span className="font-medium text-gray-900">{currentProject.project_name}</span>
          </div>
          
          <div className="flex space-x-3">
            <button
              onClick={handleSaveAndExit}
              disabled={saving}
              className="inline-flex items-center space-x-2 px-6 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200"
            >
              <FiSave className="h-4 w-4" />
              <span>{saving ? 'Saving...' : 'Save Data and Exit'}</span>
            </button>
            
            <button
              onClick={handleContinueToBuild}
              className="inline-flex items-center space-x-2 px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors duration-200"
            >
              <span>Continue to Build App</span>
              <FiArrowRight className="h-4 w-4" />
            </button>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default ActionBar;